import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Profile = (props: Icon): React.ReactElement =>
  props.variant === "line" ? (
    <svg
      style={{ ...style(props.size), ...props.style }}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 24 24"
    >
      <defs>
        <path
          d="M12,13.3333333 C15.5528367,13.3333333 18.5536259,15.0453018 18.6635479,17.3678881 L18.6666667,17.5 L18.6666667,19.3333333 C18.6666667,19.7015232 18.3681899,20.0000001 18,20.0000001 C17.6581095,20.0000001 17.3763286,19.7426399 17.3378185,19.4110808 L17.3333333,19.3333333 L17.3333333,17.5 C17.3333333,16.0390494 14.9805228,14.6666667 12,14.6666667 C9.0842712,14.6666667 6.7692594,15.9800291 6.66998465,17.4048594 L6.66666663,17.5 L6.66666663,19.3333333 C6.66666663,19.7015232 6.3681898,20.0000001 5.99999996,20.0000001 C5.6581094,20.0000001 5.37632852,19.7426399 5.33781845,19.4110808 L5.33333329,19.3333333 L5.33333329,17.5 C5.33333329,15.1105139 8.38012862,13.3333333 12,13.3333333 Z M12,3.99999995 C14.209139,3.99999995 16,5.79086096 16,7.99999995 C16,10.209139 14.209139,12 12,12 C9.79086099,12 7.99999998,10.209139 7.99999998,7.99999995 C7.99999998,5.79086096 9.79086099,3.99999995 12,3.99999995 Z M12,5.33333329 C10.5272407,5.33333329 9.33333332,6.52724063 9.33333332,7.99999998 C9.33333332,9.47275932 10.5272407,10.6666667 12,10.6666667 C13.4727593,10.6666667 14.6666667,9.47275932 14.6666667,7.99999998 C14.6666667,6.52724063 13.4727593,5.33333329 12,5.33333329 Z"
          id="path-1-profile"
        ></path>
      </defs>
      <g
        id="icon-24x24px[16x16px]---line&amp;solid"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Atom/icon/people/user/line">
          <mask id="mask-2-profile" fill={props.color || theme.palette.grey600}>
            <use xlinkHref="#path-1-profile"></use>
          </mask>
          <use
            id="Combined-Shape"
            fill={props.color || theme.palette.grey600}
            fillRule="nonzero"
            xlinkHref="#path-1-profile"
          ></use>
          <g
            id="Group"
            mask="url(#mask-2-profile)"
            fill={props.color || theme.palette.grey600}
            fillOpacity="0.6"
          >
            <g id="🎨-color">
              <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ) : (
    <svg
      style={{ ...style(props.size), ...props.style }}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 24 24"
    >
      <defs>
        <path
          d="M12,13.3333333 C8.32399998,13.3333333 5.33333329,15.2733334 5.33333329,17.658 L5.33333329,20.0000001 L18.6666667,20.0000001 L18.6666667,17.658 C18.6666667,15.2733334 15.676,13.3333333 12,13.3333333 Z M12,11.9999999 C14.206,11.9999999 16,10.206 16,7.99999995 C16,5.79399996 14.206,3.99999995 12,3.99999995 C9.79399999,3.99999995 7.99999997,5.79399996 7.99999997,7.99999995 C7.99999997,10.206 9.79399999,11.9999999 12,11.9999999 Z"
          id="path-1-profile"
        ></path>
      </defs>
      <g
        id="icon-24x24px[16x16px]---line&amp;solid"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Atom/icon/people/user/solid">
          <mask id="mask-2-profile" fill={props.color || theme.palette.grey600}>
            <use xlinkHref="#path-1-profile"></use>
          </mask>
          <use
            id="Atom/icon/user"
            fill={props.color || theme.palette.grey600}
            fillRule="nonzero"
            xlinkHref="#path-1-profile"
          ></use>
          <g
            id="Group"
            mask="url(#mask-2-profile)"
            fill={props.color || theme.palette.grey600}
            fillOpacity="0.6"
          >
            <g id="🎨-color">
              <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
